import React, { ReactElement } from 'react';
import './style.scss';
import { IconName, findIcon } from 'utils/handleIcon';
import { TwoSelections } from 'views/mutual/inputRadio';
import { CardLabel } from 'views/mutual/questionCard';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { TemplateProps } from 'views/templates/accountOpen/common';

export const SelfieQuestionTop = ({ isUpdate }: TemplateProps) => {
  const icon = findIcon(IconName.selfie);

  return (
    <>
      <div className="selfieQuestionTop">
        <CardLabel
          letter={<>{!isUpdate ? <>&#10107;</> : <>&#10103;</>}本人確認の方法について</>}
          sentence="お手持ちのスマートフォンで上記の本人確認書類と顔写真の撮影が可能ですか？"
        />
        <SvgIcon icon={icon} size={IconSize.icon_xl} />
      </div>
    </>
  );
};

interface SelfieQuestionBottomBottomProps {
  selected: boolean | null;
  onChange: (value: boolean) => void;
  error: string | undefined;
}

export const SelfieQuestionBottom = (props: SelfieQuestionBottomBottomProps) => {
  return (
    <>
      <div className="selfieQuestionBottom">
        <TwoSelections
          {...props}
          addtionalYes={<div className="selfieQuestionBottom_recommend"></div>}
          name="SelfieQuestion"
        />
      </div>
    </>
  );
};
